export default __webpack_public_path__ + "static/media/feature-left-3.72498b84.png";